import { setHours, setMinutes, setSeconds } from 'date-fns'

export const setTimeOnDate = (date, time) => {
  const [hours, minutes, seconds] = time.split(':')
  const withHours = setHours(new Date(date), Number(hours || 0))
  const withMinutes = setMinutes(withHours, Number(minutes || 0))
  const withSeconds = setSeconds(withMinutes, Number(seconds || 0))
  return withSeconds
}
